import {FC} from 'react';

import {useTranslation} from 'react-i18next';

import {Box, Divider, Stack, SxProps, Typography} from '@mui/material';

import {Editable} from './Editable';
import {JobSearchStatus, MatchingStatus} from '../../../../../domain/settings';
import {empionGreen, empionOrange} from '../../../../../layouts/theme/EmpionColors';
import * as Types from '../../types';

interface SettingsProps {
  sx?: SxProps;
  data: Types.ProfileSettings;
  onEdit?: (formType: Types.ProfileFormType) => void;
  testid?: string;
}

const Settings: FC<SettingsProps> = ({sx, data, onEdit, testid}) => {
  const {t} = useTranslation();
  const {t: td} = useTranslation('domain');
  const getColor = (isActive: boolean) => {
    if (isActive) {
      return empionGreen[100];
    }
    return empionOrange[900];
  };

  const settingItems = [
    {
      label: t('applicantProfile.form.settings.findability'),
      value: td(`profileVisibilityEnum.${data.profileVisibility}`),
      isActive: data.profileVisibility === 'public',
    },
    {
      label: t('applicantProfile.form.settings.jobSearch'),
      value: td(`jobSearchStatusEnum.${data.jobSearchStatus}`),
      isActive: data.jobSearchStatus === JobSearchStatus.ActivelyLooking,
    },
    {
      label: t('applicantProfile.form.settings.matchingStatus'),
      value: td(`matchingStatusEnum.${data.matchingStatus}`),
      isActive: data.matchingStatus === MatchingStatus.Active,
    },
  ];

  return (
    <Box sx={{...sx}}>
      <Editable onEdit={() => onEdit?.('settings')} testid={testid || 'edit-settings'} sx={{mt: '45px'}}>
        <Typography variant='h2' sx={{mb: 2}}>
          {t('applicantProfile.settings.title')}
        </Typography>
        <Stack divider={<Divider sx={{borderColor: empionOrange[3]}} />} spacing={1.5}>
          {settingItems.map((item) => (
            <Box key={item.label}>
              <Typography variant='caption' sx={{color: empionGreen[100], display: 'block', mb: 0.25}}>
                {item.label}
              </Typography>
              <Typography variant='body1' color={getColor(item.isActive)}>
                {item.value}
              </Typography>
            </Box>
          ))}
        </Stack>
      </Editable>
    </Box>
  );
};

export default Settings;
